export default __webpack_public_path__ + "static/media/main-logo.c7f12800.png";